import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {EmailCommunicationPopupComponent} from './email-communication-popup.component';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { OtpInputModule } from '../otp-input/otp-input.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgBackdropModule } from '../ng-backdrop/ng-backdrop.module';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';


@NgModule({
  declarations: [EmailCommunicationPopupComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    OtpInputModule,
    NgBackdropModule,
    MatProgressSpinnerModule
  ],
  exports: [
    EmailCommunicationPopupComponent
  ]
})
export class EmailCommunicationPopupModule { }
